/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadCalendarEventsFindAllResponse } from './LeadCalendarEventsFindAllResponse';
import {
    LeadCalendarEventsFindAllResponseFromJSON,
    LeadCalendarEventsFindAllResponseFromJSONTyped,
    LeadCalendarEventsFindAllResponseToJSON,
    LeadCalendarEventsFindAllResponseToJSONTyped,
} from './LeadCalendarEventsFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllLeadCalendarEvents200Response
 */
export interface FindAllLeadCalendarEvents200Response {
    /**
     * 
     */
    data?: LeadCalendarEventsFindAllResponse;
}

/**
 * Check if a given object implements the FindAllLeadCalendarEvents200Response interface.
 */
export function instanceOfFindAllLeadCalendarEvents200Response(value: object): value is FindAllLeadCalendarEvents200Response {
    return true;
}

export function FindAllLeadCalendarEvents200ResponseFromJSON(json: any): FindAllLeadCalendarEvents200Response {
    return FindAllLeadCalendarEvents200ResponseFromJSONTyped(json, false);
}

export function FindAllLeadCalendarEvents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllLeadCalendarEvents200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadCalendarEventsFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllLeadCalendarEvents200ResponseToJSON(json: any): FindAllLeadCalendarEvents200Response {
    return FindAllLeadCalendarEvents200ResponseToJSONTyped(json, false);
}

export function FindAllLeadCalendarEvents200ResponseToJSONTyped(value?: FindAllLeadCalendarEvents200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadCalendarEventsFindAllResponseToJSON(value['data']),
    };
}

